var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row boxes-row"},_vm._l((_vm.files),function(file){return _c('div',{key:file.idFile,staticClass:"col-lg-6"},[_c('CompanyFileBox',{attrs:{"box":file}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }